import React from 'react';
import { Link } from 'react-router-dom';

export default function RegisterForm() {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: '24px' }}>
      <h1>Hello World</h1>
      <p>Register form shell (Phase 1C).</p>
      <p>
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </main>
  );
}
